<script setup lang="ts">
/***
 * template to show array of areas
 */
import type { DataTableCellProps } from './templateTypes';
const _props = defineProps<DataTableCellProps>();
</script>

<template>
  <ExpandableCell :data-key="dataKey" :field="column.field">
    <!-- Collapsed content -->
    <template #collapsed>
      <div class="space-y-1">
        <div class="flex gap-2">
          <div>{{ cell.meta('rawvalue')[0]?.clauseSchema?.name }}</div>
          <div v-if="cell.meta('rawvalue').length > 1">[...]</div>
        </div>
      </div>
    </template>

    <!-- Expanded content -->
    <template #expanded>
      <div class="flex flex-col gap-2">
        <div v-for="arrayValue in cell.value" :key="arrayValue.id">
          <div>
            {{ arrayValue.clauseSchema.name }}
          </div>
        </div>
      </div>
    </template>
  </ExpandableCell>
</template>
